import List from "./personal_employee_leave_entitlement_list";
import Form from "./form/form.store";

export default {
  modules: { List, Form },
};
